export function formatIDR(value, opts = {}) {
  const num = Number(value || 0);
  const rounded = Math.round(num);
  const formatted = rounded.toLocaleString("id-ID");
  return opts.compact && rounded >= 1000000
    ? `Rp ${(rounded / 1000000).toFixed(rounded % 1000000 === 0 ? 0 : 1)}jt`
    : `Rp ${formatted}`;
}

export function formatNumber(value) {
  return Number(value || 0).toLocaleString("id-ID");
}
